import { Box } from '@material-ui/core';

import { SBase, SButton, SText } from '@setvi/shared/components';

interface PreviewUnavailableProps {
  title: string;
  loading: boolean;
  /** Falls back to the web viewer, which can render what the dialog cannot. */
  onOpenInViewer: () => void;
  onClose: () => void;
}

/** Shown while the resource resolves, and when it has no previewable file. */
export const PreviewUnavailable = ({
  title,
  loading,
  onOpenInViewer,
  onClose
}: PreviewUnavailableProps) => (
  <SBase width="95vw" height="95vh" header={{ title, onClose }}>
    <Box
      height="100%"
      display="flex"
      gridGap={16}
      alignItems="center"
      flexDirection="column"
      justifyContent="center">
      {loading ? (
        <SText title="Loading preview…" fontColor="#5D7083" />
      ) : (
        <>
          <SText title="Preview is not available for this resource." />
          <SButton variant="outlined" onClick={onOpenInViewer}>
            Open in viewer
          </SButton>
        </>
      )}
    </Box>
  </SBase>
);
